import React, { createContext, useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ActualizarFinanciamientoModal from "./ActualizarFinanciamientoModal";

export const ContextConvenio = createContext();
export const DiferenciasVencimientoScreen = () => {
    const history = useHistory();
    const [selected, setSelected] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const handleOpenModal = (folio) => {
        setSelected(folio);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`FacturasDiferenciaVencimiento/Facturas`)
            .then((result) => {
                setFacturas(result);
                // setArrayClientes(result);
                setLoader({ ...loader, mostrar: false });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CONVENIO DE PAGO", JSON.stringify(error), "error");
            });
    }, []);


    const capitalizeWords = (text) => {
        return text
            .toLowerCase()
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <PlantillaScreen
            titulo={"DIFERENCIAS EN FECHAS DE VENCIMIENTO"}
            className={"diferencias-vencimiento-main-screen"}
            className_main={1}
        >
                <ActualizarFinanciamientoModal
                    open={openModal}
                    onClose={handleCloseModal}
                    folio={selected}
                />
            <div className="diferencias-vencimiento-actions">
                <div
                    className="diferencias-vencimiento-actions-regresar"
                    onClick={() => history.push('/Credito/Main')}
                >
                    <ArrowBackIcon /> Regresar
                </div>
                <div className="diferencias-vencimiento-actions-filtro">
                </div>
            </div>
            <div className="contador-clientes-encontrados">
                Facturas Encontradas: {facturas.length}
            </div>
            <LoaderScreen loader={loader} />
            <div className="diferencias-vencimiento-screen">
                <div className="diferencias-vencimiento-container scroll-4">
                    {facturas !== undefined &&
                        facturas !== null &&
                        facturas.length > 0 ? (
                        <table cellSpacing={0} cellPadding={0}>
                            <thead>
                                <tr>
                                    <th>
                                        Folio
                                    </th>
                                    <th>
                                        <div>Sucursal</div>
                                    </th>
                                    <th>
                                        <div>Cliente</div>
                                    </th>
                                    <th>
                                        <div>Folio Fiscal</div>
                                    </th>
                                    <th>
                                        <div>Documento</div>
                                    </th>
                                    <th>
                                        <div>Importe a Financiar</div>
                                    </th>
                                    <th>
                                        <div>Interes</div>
                                    </th>
                                    <th>
                                        <div>Vencimiento en HD</div>
                                    </th>
                                    <th>
                                        <div>Vencimiento en EQUIP</div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {facturas.map((fac) => (
                                    <tr
                                    onClick={() =>
                                        handleOpenModal(fac.folio)
                                    }
                                    >
                                        <td className="folio-celda">{fac.folio}</td>
                                        <td className="">{fac.sucursal}</td>
                                        <td className="razon-social-celda">{capitalizeWords(fac.razon_social)}</td>
                                        <td className="folio-celda">{fac.folio_fiscal}</td>
                                        <td className="documento-celda">{fac.documento}</td>
                                        <td className={`saldo-celda ${fac.vencimiento_HD === null ? "text-left" : ""}`}>
                                            {fac.vencimiento_HD === null ? "No registrado en HD" : FormatMoney(fac.importefinanciar)}
                                        </td>
                                        <td className={`saldo-celda ${fac.vencimiento_HD === null ? "text-left" : ""}`}>
                                            {fac.vencimiento_HD === null ? "No registrado en HD" : FormatMoney(fac.interes)}
                                        </td>
                                        <td className={`fecha-celda ${fac.vencimiento_HD === null ? "text-left" : ""}`}>
                                            {fac.vencimiento_HD === null
                                                ? "No registrado en HD"
                                                : fac.vencimiento_HD}
                                        </td>
                                        <td className="fecha-celda">{fac.vencimiento_EQUIP}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <div>Sin Datos</div>
                    )}
                </div>

            </div>
        </PlantillaScreen>
    );
};
